import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../context/AuthContext';
import { useRestaurantContext } from '../../context/RestaurantContext';

const MobileMenuDropdown = ({ cartCount = 0, onClose }) => {
  const navigate = useNavigate();
  const { currentUser, signOutUser, openAuthModal, isGuest, openGuestSignOutDialog } = useAuth();
  const { restaurantId } = useRestaurantContext();
  const dropdownRef = useRef(null);

  const handleSignOutClick = () => {
    if (isGuest) {
      openGuestSignOutDialog();
      onClose();
    } else {
      signOutUser();
      onClose();
    }
  };

  const baseTabs = [
    // {
    //   id: 'restaurant',
    //   label: 'Restaurant',
    //   icon: 'Home',
    //   path: restaurantId ? '/restaurant' : null,
    // },
    {
      id: 'menu',
      label: 'Menu',
      icon: 'Menu',
      path: restaurantId ? `/restaurant/${restaurantId}` : null,
    },
  ];

  let visibleTabs = [...baseTabs];

  if (currentUser) {
    visibleTabs.push({
      id: 'cart',
      label: 'Cart',
      icon: 'ShoppingCart',
      path: restaurantId ? `/restaurant/${restaurantId}/checkout` : null,
      badge: cartCount > 0 ? cartCount : null,
    });

    visibleTabs.push({
      id: 'orders',
      label: 'Orders',
      icon: 'Receipt',
      path: restaurantId ? `/restaurant/${restaurantId}/orders` : null,
    });
  }

  const tabs = visibleTabs;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const handleTabClick = (tab) => {
    if (tab.path) {
      navigate(tab.path);
      onClose();
    }
  };

  const handleAuthAction = (action) => {
    openAuthModal(action);
    onClose();
  };

  const handleSignOut = async () => {
    await signOutUser();
    onClose();
  };

  return (
    <div
      ref={dropdownRef}
      className="ease absolute top-full right-0 mt-2 w-40 bg-card border border-border rounded-md shadow-lg z-50 animate-scale-in origin-top-right"
    >
      {/* Auth Section */}
      <div className="p-2 border-b border-border">
        {currentUser ? (
          <div className="flex items-center space-x-2 p-2">
            {currentUser.photoURL ? (
              <img
                src={currentUser.photoURL}
                alt="User"
                className="w-8 h-8 rounded-full object-cover"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center">
                <Icon name="User" size={20} className="text-muted-foreground" />
              </div>
            )}
            <div className="truncate">
              <p className="text-sm font-medium truncate">
                {currentUser?.email?.split('@')[0] || "Guest User"}
              </p>
              <p className="text-xs text-muted-foreground">
                {isGuest ? "Guest User" : "Registered User"}
              </p>
            </div>
          </div>
        ) : (
          <button
            onClick={() => handleAuthAction()}
            className="flex w-full text-left px-2 py-1.5 text-sm text-primary hover:bg-muted rounded-md"
          >
            <Icon name="User" className="mr-2" size={16} />
            Sign In/Up
          </button>
        )}
      </div>

      {/* Navigation Tabs */}
      <div className="py-1">
        {tabs.map((tab) => {
          const isDisabled = !tab.path;
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              disabled={isDisabled}
              className={`w-full flex items-center px-4 py-2 text-sm text-left hover:bg-muted transition-smooth ${
                isDisabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <Icon name={tab.icon} size={16} className="mr-2" />
              <span>{tab.label}</span>
              {tab.badge && (
                <span className="ml-auto min-w-[18px] h-[18px] bg-accent text-accent-foreground text-xs font-medium rounded-full flex items-center justify-center px-1 animate-scale-in">
                  {tab.badge > 99 ? "99+" : tab.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Sign Out */}
      {currentUser && (
        <div className="p-2 border-t border-border ">
          <button
            onClick={handleSignOutClick}
            className="flex item-center w-full text-left px-2 py-1.5 text-sm text-destructive hover:bg-muted rounded-md"
          >
            <Icon name="LogOut" className="mr-2" size={16} />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default MobileMenuDropdown;
